module.exports = __webpack_public_path__ + "img/ranking.9127e2e4.svg";